import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Cookie } from "lucide-react";

const KEY = "sp_cookie_consent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(KEY);
      if (!stored) setVisible(true);
    } catch {
      setVisible(true);
    }
  }, []);

  const choose = (value) => {
    try {
      localStorage.setItem(
        KEY,
        JSON.stringify({ value, timestamp: new Date().toISOString() })
      );
    } catch {}
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          role="dialog"
          aria-label="Cookie-Einstellungen"
          data-testid="cookie-banner"
          className="fixed inset-x-0 bottom-0 z-[70] p-4 sm:p-6"
        >
          <div className="glass-strong mx-auto max-w-5xl rounded-sm border border-white/10 p-5 sm:p-6 flex flex-col md:flex-row md:items-center gap-5 md:gap-8">
            <div className="flex items-start gap-4 flex-1">
              <div className="hidden sm:flex h-11 w-11 shrink-0 items-center justify-center rounded-sm border border-white/10 text-cyan-glass">
                <Cookie className="h-5 w-5" strokeWidth={1.5} />
              </div>
              <div>
                <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-cyan-glass mb-2">
                  Cookies & Datenschutz
                </div>
                <p className="text-sm text-white/70 font-light leading-relaxed">
                  Wir verwenden Cookies, um unsere Website bestmöglich für Sie darzustellen. Notwendige Cookies sind für den Betrieb der Seite erforderlich. Weitere Cookies helfen uns, das Angebot zu verbessern. Mehr in unserer{" "}
                  <a href="/datenschutz" className="text-cyan-glass hover:underline">
                    Datenschutzerklärung
                  </a>
                  .
                </p>
              </div>
            </div>

            <div className="flex flex-col-reverse sm:flex-row gap-3 shrink-0">
              <button
                type="button"
                onClick={() => choose("necessary")}
                data-testid="cookie-necessary"
                className="rounded-full border border-white/20 px-6 py-3 font-mono text-[11px] uppercase tracking-[0.15em] text-white transition-colors duration-200 hover:border-cyan-glass hover:text-cyan-glass"
              >
                Nur notwendige
              </button>
              <button
                type="button"
                onClick={() => choose("all")}
                data-testid="cookie-accept-all"
                className="rounded-full bg-cyan-glass px-6 py-3 font-mono text-[11px] uppercase tracking-[0.15em] text-[#030712] font-medium transition-transform duration-200 active:scale-95 hover:shadow-[0_0_30px_rgba(0,229,255,0.4)]"
              >
                Alle akzeptieren
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
